import React from "react";

import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

interface Props {
  onClick: () => void;
}

const SwitchToSandboxButton: React.FC<Props> = ({ onClick }) => {
  const intl = useIntl();
  return (
    <Button onClick={onClick} size="small" type="primary">
      {intl.formatMessage({
        id: "settings.sandboxEnvironment.state.switch",
        defaultMessage: "Switch to sandbox",
        description: "Settings Sandbox Environment - state - Switch to sandbox",
      })}
    </Button>
  );
};

export default SwitchToSandboxButton;
